import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

const state = {
    id: 0,
    // presupuestoInternoId: 0,
    // presupuestoNumero: '',
    // cliente: '',
    // accion: '',
    briefId: 0,
    titulo: '',
    descripcion: '',
    fechaEntrega: '1900-01-01',
    prioridadId: 0,
    prioridad: null,
    prioridadNombre: null,
    briefTareaEstadoId: 0,
    briefTareaEstado: null,
    briefTareaEstadoNombre: null,
    usuarioId: 0,
    usuario: null,
    usuarioNombre: null,
    rowVersion: null,

    prioridades: [],
    prioridadesList: [],
    estados: [],
    estadosList: [],

    isDirty: false,
    briefTareaId: 0
};

const mutations = {
    updateField(state, field) {
        updateField(state, field);

        state.isDirty = true;
        // console.log(field);
    },

    'INICIALIZAR'(state, params) {
        state.id = params.briefTareaId;
        // state.presupuestoInternoId = 0;
        // state.presupuestoNumero = '';
        // state.cliente = '';
        // state.accion = '';
        state.briefId = params.briefId;
        state.titulo = '';
        state.descripcion = '';
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD');
        state.prioridadId = 0;
        state.prioridad = null;
        state.prioridadNombre = null;
        state.briefTareaEstadoId = 0;
        state.briefTareaEstado = null;
        state.briefTareaEstadoNombre = null;
        state.usuarioId = 0;
        state.usuario = null;
        state.usuarioNombre = null;
        state.rowVersion = null;

        state.isDirty = false;
    },
    'SET_PRIORIDADES' (state, prioridades) {
        state.prioridades = prioridades.sort(function(a, b){
            let x = a.nombre.toLowerCase();
            let y = b.nombre.toLowerCase();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        
        state.prioridadesList = state.prioridades.map(prioridad => prioridad.nombre.trim());
    },
    'SET_ESTADOS' (state, estados) {
        state.estados = estados.sort(function(a, b){
            let x = a.nombre.toLowerCase();
            let y = b.nombre.toLowerCase();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        state.estadosList = state.estados.map(estado => estado.nombre.trim());
    },
    'SET_BRIEF_TAREA'(state, briefTarea) {
        state.briefId = briefTarea.briefId;
        state.titulo = briefTarea.titulo.trim();
        state.descripcion = briefTarea.descripcion.trim();
        if (moment(briefTarea.fechaEntrega).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaEntrega = moment(briefTarea.fechaEntrega).format('YYYY-MM-DD');
        }
        state.prioridadId = briefTarea.prioridadId;
        state.prioridad = briefTarea.prioridad;
        state.prioridadNombre = briefTarea.prioridad? briefTarea.prioridad.nombre.trim() : null;
        state.briefTareaEstadoId = briefTarea.briefTareaEstadoId;
        state.briefTareaEstado = briefTarea.briefTareaEstado;
        state.briefTareaEstadoNombre = briefTarea.briefTareaEstado? briefTarea.briefTareaEstado.nombre.trim() : null;
        state.usuarioId = briefTarea.usuarioId;
        state.usuario = briefTarea.usuario;
        state.usuarioNombre = briefTarea.usuario? briefTarea.usuario.nombreCompleto.trim() : null;
        state.rowVersion = briefTarea.rowVersion;

        if (state.prioridadId != 0) {
            var prioridad = state.prioridades.find(t => t.id == state.prioridadId);
            if (!prioridad) {
                state.prioridades.push({
                    id: state.prioridadId,
                    nombre: state.prioridad.nombre.trim()
                });

                state.prioridades = state.prioridades.sort(function(a, b){
                    /* Ordenamos por condición de inactivo */
                    if (!a.inactivo & b.inactivo) {
                        return -1;
                    }
                    if (a.inactivo & !b.inactivo) {
                        return 1;    
                    }
                    let x = a.nombre.toLowerCase().trim();
                    let y = b.nombre.toLowerCase().trim();
                    if (x < y) { 
                        return -1; 
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });

                state.prioridadesList = state.prioridades.map(prioridad => prioridad.nombre.trim());
            }
        }

        if (state.briefTareaEstadoId != 0) {
            var estado = state.estados.find(t => t.id == state.briefTareaEstadoId);
            if (!estado) {
                state.estados.push({
                    id: state.briefTareaEstadoId,
                    nombre: state.briefTareaEstado.nombre.trim()
                });

                state.estados = state.estados.sort(function(a, b){
                    /* Ordenamos por condición de inactivo */
                    if (!a.inactivo & b.inactivo) {
                        return -1;
                    }
                    if (a.inactivo & !b.inactivo) {
                        return 1;    
                    }
                    let x = a.nombre.toLowerCase().trim();
                    let y = b.nombre.toLowerCase().trim();
                    if (x < y) { 
                        return -1; 
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });

                state.estadosList = state.estados.map(estado => estado.nombre.trim());
            }
        }

        state.isDirty = false;
    },
    'SET_PRIORIDAD' (state, prioridad) {
        state.prioridad = prioridad;
        if (prioridad) {
            state.prioridadId = prioridad.id? prioridad.id : 0;
            state.prioridadNombre = prioridad.nombre? prioridad.nombre.trim() : null;
        } else {
            state.prioridadId = 0;
            state.prioridadNombre = null;
        }
        state.isDirty = true;
    },
    'SET_ESTADO' (state, briefTareaEstado) {
        state.briefTareaEstado = briefTareaEstado;
        if (briefTareaEstado) {
            state.briefTareaEstadoId = briefTareaEstado.id? briefTareaEstado.id : 0;
            state.briefTareaEstadoNombre = briefTareaEstado.nombre? briefTareaEstado.nombre.trim() : null;
        } else {
            state.briefTareaEstadoId = 0;
            state.briefTareaEstadoNombre = null;
        }
        state.isDirty = true;
    },
    'SET_USUARIO' (state, usuario) {
        state.usuario = usuario;
        if (usuario) {
            state.usuarioId = usuario.id? usuario.id : 0;
            state.usuarioNombre = usuario.nombreCompleto? usuario.nombreCompleto.trim() : null;
        } else {
            state.usuarioId = 0;
            state.usuarioNombre = null;
        }
        state.isDirty = true;
    },
    'SET_BRIEF_TAREA_ID'(state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },
};

const getters = {
    getField,

    dirty(state) {
        if ((/true/i).test(state.isDirty)) {
            return true;
        }

        return false;
    },

    briefTareaId(state) {
        return state.briefTareaId;
    },
    briefTarea(state) {
        return {
            id: state.id,
            briefId: state.briefId,
            titulo: state.titulo.toUpperCase(),
            descripcion: state.descripcion,
            fechaEntrega: state.fechaEntrega,
            prioridadId: state.prioridadId,
            prioridad: state.prioridad,
            briefTareaEstadoId: state.briefTareaEstadoId,
            briefTareaEstado: state.briefTareaEstado,
            usuarioId: state.usuarioId,
            usuario: state.usuario,
            rowVersion: state.rowVersion
        }
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            let getTarea = false;
            if (params.briefTareaId) {
                if (params.briefTareaId != 0) {
                    getTarea = true;
                }
            }

            if (getTarea) {
                apiAxios.get('prioridades/list') 
                    .then(res => {
                        commit('SET_PRIORIDADES', res.data);

                        return apiAxios.get(`briefs/tareas/estados/list`);
                    })
                    .then(res => {
                        commit('SET_ESTADOS', res.data);

                        return apiAxios.get(`briefs/tareas/${params.briefTareaId}/abm`);
                    })
                    .then(res => {
                        commit('SET_BRIEF_TAREA', res.data);

                        resolve();
                    })
                    .catch(error => reject(error))

            } else {
                apiAxios.get('prioridades/list') 
                    .then(res => {
                        commit('SET_PRIORIDADES', res.data);

                        return apiAxios.get(`briefs/tareas/estados/list`);
                    })
                    .then(res => {
                        commit('SET_ESTADOS', res.data);

                        resolve();
                    })
                    .catch(error => reject(error))
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            // let usuarioId = rootGetters['user/userId'];

            let briefTarea = {
                briefId: state.briefId,
                titulo: state.titulo.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                fechaEntrega: moment(state.fechaEntrega).format('YYYY-MM-DD'),
                prioridadId: state.prioridadId,
                briefTareaEstadoId: state.briefTareaEstadoId,
                usuarioId: state.usuarioId
            }

            let url = 'briefs/tareas'
            if (state.id != 0) {
                url += `/${state.id}`;
                briefTarea.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, briefTarea)
                .then(res => {
                    commit('SET_BRIEF_TAREA_ID', res.data);
                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPrioridad ( { commit }, prioridad) {
        return new Promise((resolve, reject) => {
            commit('SET_PRIORIDAD', prioridad);
            resolve();
        })
    },
    setEstado ( { commit }, estado) {
        return new Promise((resolve, reject) => {
            commit('SET_ESTADO', estado);
            resolve();
        })
    },
    setUsuario ( { commit }, usuario) {
        return new Promise((resolve, reject) => {
            commit('SET_USUARIO', usuario);
            resolve();
        })
    },
    setBrief ( { commit }, brief) {
        return new Promise((resolve, reject) => {
            commit('SET_BRIEF', brief);
            resolve();
        })
    },
    clearBrief ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CLEAR_BRIEF');
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}